<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'TaxIndex'
}
</script>

<style scoped>

</style>
